export enum OrderForwardListParamsOrder {
  CONSUMER_ASC = "CONSUMER_ASC",
  CONSUMER_DESC = "CONSUMER_DESC",
  PRODUCER_ASC = "PRODUCER_ASC",
  PRODUCER_DESC = "PRODUCER_DESC",
}

type OrderForwardListParams = {
  order?: OrderForwardListParamsOrder;
  limit?: number;
  offset?: number;
  startTimeSince?: string;
  startTimeTo?: string;
  humanId?: number;
  address?: string;
  startAddress?: string;
  midAddress?: string;
  endAddress?: string;
  passenger?: string;
  producer?: string;
  consumer?: string;
  externalId?: string;
  driver?: string;
};

export default OrderForwardListParams;
